import { render } from "./UserFilesPage.vue?vue&type=template&id=3b66fad0"
import script from "./UserFilesPage.vue?vue&type=script&lang=js"
export * from "./UserFilesPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__